import React from 'react';
import Layout from '../components/layout/Layout';
import { companyInfo } from '../data/mock';

const PrivacyPage = () => {
  return (
    <Layout>
      {/* Header */}
      <div className="bg-gradient-to-br from-emerald-50 to-green-50 py-10">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">Политика конфиденциальности</h1>
          <p className="text-gray-600">{companyInfo.owner}</p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
          <div className="prose prose-emerald max-w-none">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Общие положения</h2>
            <p className="text-gray-600 mb-4">
              Настоящая политика обработки персональных данных составлена в соответствии с требованиями 
              Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» и определяет порядок 
              обработки персональных данных и меры по обеспечению безопасности персональных данных, 
              предпринимаемые {companyInfo.owner} (далее – Оператор).
            </p>
            <p className="text-gray-600 mb-6">
              Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение 
              прав и свобод человека и гражданина при обработке его персональных данных, в том числе защиты 
              прав на неприкосновенность частной жизни, личную и семейную тайну.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Основные понятия</h2>
            <ul className="text-gray-600 mb-6 list-disc pl-6 space-y-2">
              <li><strong>Персональные данные</strong> — любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных).</li>
              <li><strong>Обработка персональных данных</strong> — любое действие с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, использование, передачу, обезличивание, блокирование, удаление, уничтожение.</li>
              <li><strong>Оператор</strong> — {companyInfo.owner}.</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Цели обработки персональных данных</h2>
            <p className="text-gray-600 mb-4">
              Оператор обрабатывает персональные данные Пользователя в следующих целях:
            </p>
            <ul className="text-gray-600 mb-6 list-disc pl-6 space-y-2">
              <li>Обработка входящих запросов и заявок от физических лиц с целью оказания консультационных услуг;</li>
              <li>Информирование Пользователя о товарах и услугах Оператора;</li>
              <li>Заключение и исполнение договоров купли-продажи теплиц;</li>
              <li>Обеспечение доставки заказанных товаров.</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Объем и категории обрабатываемых персональных данных</h2>
            <p className="text-gray-600 mb-4">
              Оператор может обрабатывать следующие персональные данные Пользователя:
            </p>
            <ul className="text-gray-600 mb-6 list-disc pl-6 space-y-2">
              <li>Фамилия, имя, отчество;</li>
              <li>Номер телефона;</li>
              <li>Адрес электронной почты;</li>
              <li>Адрес доставки;</li>
              <li>Иные данные, необходимые для исполнения договора.</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Права пользователя</h2>
            <p className="text-gray-600 mb-4">
              Пользователь имеет право:
            </p>
            <ul className="text-gray-600 mb-6 list-disc pl-6 space-y-2">
              <li>Получать информацию, касающуюся обработки его персональных данных;</li>
              <li>Требовать уточнения своих персональных данных, их блокирования или уничтожения;</li>
              <li>Отозвать согласие на обработку персональных данных;</li>
              <li>Обжаловать действия или бездействие Оператора в уполномоченный орган.</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Условия обработки персональных данных</h2>
            <p className="text-gray-600 mb-4">
              Обработка персональных данных осуществляется с согласия субъекта персональных данных на 
              обработку его персональных данных. Согласие дается путем заполнения формы на сайте и 
              отправки заявки.
            </p>
            <p className="text-gray-600 mb-6">
              Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, 
              исключающие доступ к персональным данным неуполномоченных лиц.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Контактная информация Оператора</h2>
            <div className="text-gray-600 space-y-2">
              <p><strong>Оператор:</strong> {companyInfo.owner}</p>
              <p><strong>Адрес:</strong> {companyInfo.address}</p>
              <p><strong>Телефон:</strong> {companyInfo.phone}</p>
              <p><strong>Email:</strong> {companyInfo.email}</p>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <p className="text-gray-500 text-sm">
                Дата публикации: 01 января 2025 года
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPage;
